import ChatAnalyticPage from './chat-analytic.page';
export default ChatAnalyticPage;
